import _ from 'underscore';

import isArchived from 'archive/isArchived';
import {DataTableColumn} from 'notebook/data-tables/DataTableConstants';
import {ClientSchemaField} from 'registry/field/FieldTable';
import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {Schema} from 'schemas/SchemaConstants';

import isSchemaFieldArchived from './isSchemaFieldArchived';

export function getArchivedFields(schema: Schema): Array<SchemaField> {
  return schema.allFields.filter((field) => isSchemaFieldArchived(field));
}

export function getFieldForColumn(schema: AssaySchema, column: DataTableColumn): SchemaField | undefined {
  return _.findWhere(schema.allFields, {id: column.tagSchemaFieldId});
}

export function getNonArchivedOrComputedFields<T extends SchemaField | ClientSchemaField>(
  fields: Array<T>
): Array<T> {
  // eslint-disable-next-line no-restricted-syntax
  return _.reject(fields, (field) => field.isComputed || isArchived({...field, id: field.apiId ?? ''}));
}
